import React from 'react'
import styles from './Toolbar.module.css'
import Navigationitems from '../Navigationitems/Navigationitems'


const toolbar = () => (
<div className={styles.ToolBar}>
<Navigationitems/>
</div>
)

export default toolbar